import { render, staticRenderFns } from "./PaKolIndex.vue?vue&type=template&id=355fbdca&scoped=true"
import script from "./PaKolIndex.vue?vue&type=script&lang=js"
export * from "./PaKolIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355fbdca",
  null
  
)

export default component.exports